import React, { useContext, useState, useEffect, useRef } from "react";
import Package from "../../components/adminComponents/Package";
import NewsItem from "../../components/adminComponents/NewsItem";
//import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
//import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import { GeneralContext } from "../../context/GeneralContext";
import { api } from "../../utils/authActions";
import { hasProperty } from "../../utils/helpers";
import "./profilePages.scss";
import { getPackageFromList } from "../../components/adminComponents/adminLogic";
import Modal from "react-modal";
import PollSolver from "../../components/adminComponents/polling/PollSover";

function ProfileHome() {
  const {
    authToken,
    isAuthReady,
    packages,
    setPackages,
    setIsActive,
    //isActive,
    setAccessLevel,
    accessLevel,
    currentUser,
  } = useContext(AuthContext);
  const {
    activePolls,
    setActivePolls,
    pollToSolve,
    setPollToSolve,
    recordedErrorLog,
    limitedSucessToast,
    limitedToast,
  } = useContext(GeneralContext);
  const [activePacks, setActivePacks] = useState([]);
  //const [expiredPacks, setExpiredPacks] = useState([]);
  const [purchaseModalOpen, setPurchaseModalOpen] = useState(false);
  const [academicDiscountModalOpen, setAcademicDiscountModalOpen] =
    useState(false);
  // const [activePolls, setActivePolls] = useState([]);
  // const [pollToSolve, setPollToSolve] = useState(null);
  const [newsMessages, setNewsMessages] = useState([]);
  const [showAllNews, setShowAllNews] = useState(false);
  const [taxingPurposeModalOpen, setTaxingPurposeModalOpen] = useState(false);
  const [paymentFrequencyModalOpen, setPaymentFrequencyModalOpen] =
    useState(false);
  const [pendingPurchaseData, setPendingPurchaseData] = useState(null);
  const [pendingTaxingPurpose, setPendingTaxingPurpose] = useState(null);
  const profileHomeRef = useRef();

  //const navigate = useNavigate();

  // const handleSpeqqleRedirect = () => {
  //   navigate("/dashboard");
  // };

  function isTodayOrFuture(dateString) {
    try {
      const inputDate = new Date(dateString + "T00:00:00Z"); // Parse as UTC
      const today = new Date();

      // Set the hours, minutes, seconds, and milliseconds of today's date to 0
      // This way, we're only comparing the year, month, and day
      today.setHours(0, 0, 0, 0);

      return inputDate >= today;
    } catch (error) {
      recordedErrorLog("isTodayOrFuture function failure: ", error);
    }
  }

  useEffect(() => {
    if (isAuthReady && authToken !== "") {
      // Handle Stripe checkout success/failure
      const urlParams = new URLSearchParams(window.location.search);
      const paymentStatus = urlParams.get("payment");

      if (paymentStatus === "canceled") {
        limitedToast("Payment was cancelled. You can try again anytime.");
        // Clean up URL
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      } else if (paymentStatus === "success") {
        // Payment successful - packages should be auto-activated by webhook
        limitedSucessToast("Payment successful! Package has been activated.");
        setIsActive(true);

        // Clean up URL
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }

      // get user packages for current user
      api
        .getMyPackages(authToken)
        .then((response) => {
          let active = [];
          let expired = [];
          for (let i = 0; i < response.data.length; i++) {
            const pack = response.data[i];
            if (isTodayOrFuture(pack.end)) {
              active.push(pack);
            } else {
              expired.push(pack);
            }
          }
          setActivePacks(active);
          //      setExpiredPacks(expired);
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR WITH USER PACKAGES: ${errorDetails}`,
            err,
            true,
            "Unexpected error occurred retrieving user packages. Please try again later, or contact support."
          );
        });

      api
        // get active polls for user
        .getActivePolls(authToken)
        .then((response) => {
          setActivePolls(response.data);
          if (response.data.length > 0) {
            setPollToSolve(response.data[0]);
          }
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          recordedErrorLog(
            `THERE WAS AN ERROR WITH ACTIVE POLLS: ${errorDetails}`,
            err,
            false,
            ""
          );
        });

      api
        .getAccessLevel(authToken)
        .then((response) => {
          setAccessLevel(response.data);
        })
        .catch((err) => {
          recordedErrorLog("Error getting access level: ", err);
        });

      // Get latest news messages
      api
        .getUserNewsMessages(authToken, {
          num_messages: showAllNews ? 100 : 10,
        })
        .then((response) => {
          setNewsMessages(response.data);
        })
        .catch((err) => {
          recordedErrorLog("Error getting news messages: ", err);
        });
    }
  }, [isAuthReady, showAllNews]);

  const handlePurchaseModalClose = () => {
    setPurchaseModalOpen(false);
  };

  const handleDeactivatePackage = async (id) => {
    try {
      await api.deactivatePackageForMe(authToken, id);
      limitedSucessToast("Package deactivated successfully.");
      // Refresh packages to get updated availability
      api
        .getMyPackages(authToken)
        .then((response) => {
          let active = [];
          let expired = [];
          for (let i = 0; i < response.data.length; i++) {
            const pack = response.data[i];
            if (isTodayOrFuture(pack.end)) {
              active.push(pack);
            } else {
              expired.push(pack);
            }
          }
          setActivePacks(active);
        })
        .catch((err) => {
          recordedErrorLog(
            "Error refreshing packages after deactivation: ",
            err
          );
        });
    } catch (error) {
      recordedErrorLog("Error deactivating package: ", error);
      limitedToast("Failed to deactivate package. Please try again.");
    }
  };

  const handlePurchaseInit = async (price, package_id) => {
    console.log("price: ", price, "package_id: ", package_id);
    if (price === 0) {
      // self activate package
      api
        .addPackToSelf(authToken, package_id)
        .then((response) => {
          try {
            setActivePacks((old) => [...old, response.data]);
            setPackages((old) =>
              old.map((entry) => {
                if (entry.id === package_id) {
                  return { ...entry, available: false };
                }
                return entry;
              })
            );
          } catch (error) {
            console.error("error setting active packs: ", error);
          }
          setIsActive(true);
          limitedSucessToast("Package activated successfully.");
        })
        .catch((err) => {
          const errorDetails = hasProperty(err, "response")
            ? `Backend response: ${JSON.stringify(err.response, null, 2)}`
            : "No backend response available";
          if (
            hasProperty(err, "response") &&
            hasProperty(err.response, "status") &&
            err.response.status === 409
          ) {
            limitedToast(err.response.data.detail);
          } else {
            recordedErrorLog(
              `THERE WAS AN ERROR WITH PACKAGE ADD: ${errorDetails}`,
              err,
              true,
              "Unexpected error occurred activating the package. Please try again later, or contact support."
            );
          }
        });
    } else {
      // For paid packages, show taxing purpose modal first
      setPendingPurchaseData({ price, package_id });
      setTaxingPurposeModalOpen(true);
    }
  };

  const handleTaxingPurposeSelection = (purpose) => {
    setTaxingPurposeModalOpen(false);
    if (!pendingPurchaseData) return;
    setPendingTaxingPurpose(purpose);
    setPaymentFrequencyModalOpen(true);
  };

  const handlePaymentFrequencySelection = async (frequency) => {
    setPaymentFrequencyModalOpen(false);

    if (!pendingPurchaseData || !pendingTaxingPurpose) return;

    const { price, package_id } = pendingPurchaseData;
    console.log("price: ", price, "package_id: ", package_id);
    const purpose = pendingTaxingPurpose;
    setPendingPurchaseData(null);
    setPendingTaxingPurpose(null);

    try {
      // First get the current user data
      const userResponse = await api.getMe(authToken);
      const userData = userResponse.data;

      // Modify the is_personal_user value based on taxing purpose selection
      const isPersonalUser = purpose === "private";
      const updatedUserData = {
        ...userData,
        is_personal_user: isPersonalUser,
      };

      // Send the entire updated user object back
      await api.updateMe(authToken, updatedUserData);

      // Handle paid packages with Stripe checkout
      const checkoutData = await api.createStripeCheckoutSession(authToken, {
        package_id: package_id,
        success_url: `${window.location.origin}/profile?payment=success`,
        cancel_url: `${window.location.origin}/profile?payment=canceled`,
        taxing_purpose: purpose,
        billing_interval: frequency, // "monthly" or "yearly"
      });

      // Redirect to Stripe Checkout using the checkout_url from backend
      window.location.href = checkoutData.data.checkout_url;
    } catch (error) {
      recordedErrorLog(
        "Unexpected error in checkout process: ",
        error,
        true,
        "Unexpected error occurred. Please try again later."
      );
    }
  };

  const handleSolvedPoll = (pollId) => {
    try {
      const filteredActivePolls = activePolls.filter(
        (poll) => poll.id !== pollId
      );

      setActivePolls(filteredActivePolls);

      if (filteredActivePolls.length > 0) {
        setPollToSolve(filteredActivePolls[0]);
      } else {
        setPollToSolve(null);
      }
    } catch (error) {
      recordedErrorLog("Poll solve handler has failed: ", error);
    }
  };

  const handleIncludeOlderNews = () => {
    setShowAllNews(true);
  };

  const isPackAvailable = (pack) => {
    if (!pack.available) {
      return false;
    }
    if (!pack.excludes_other_packages) {
      return true;
    }

    let exclussiveAccessLevel = 0;
    for (let i = 0; i < activePacks.length; i++) {
      const foundPack = getPackageFromList(packages, activePacks[i].package_id);
      if (foundPack === undefined) {
        continue;
      }
      if (
        foundPack.excludes_other_packages &&
        foundPack.level > exclussiveAccessLevel
      ) {
        exclussiveAccessLevel = foundPack.level;
      }
    }
    if (pack.level > exclussiveAccessLevel) {
      return true;
    }
    return false;
  };

  return (
    <div className="profilePage" ref={profileHomeRef}>
      {/* <div className="redirectButtons" style={{ zIndex: 1000, position: 'relative' }}>
        {isActive > 0 ? (
          <Button
            variant="contained"
            onClick={() => handleSpeqqleRedirect()}
            className="toSpeqqleButton"
            id="to-dashboard"
          >
            To Speqqle <ArrowForwardIosIcon />
          </Button>
        ) : (
          <></>
        )}
      </div> */}
      <div
        className="profileHomeContainer"
        style={{ flexWrap: "nowrap", marginTop: "70px" }}
      >
        <div
          className="packagesSection"
          style={{
            zIndex: 100,
            position: "relative",
            minWidth: "500px",
            maxWidth: "800px",
          }}
        >
          <div className="packageSecTitle">Welcome to app.speqqle!</div>
          {currentUser && accessLevel < 10 && (
            <div
              className="packageSecTitle"
              style={{
                fontSize: "20px",
                fontWeight: "normal",
                marginTop: "5px",
              }}
            >
              If you have any questions, or would like to extend your access to
              our platform, please contact us at{" "}
              <a href="mailto:contact@speqqle.com?subject=Access to Speqqle Basic">
                contact@speqqle.com
              </a>
            </div>
          )}
          {/* <div
            className="packageSecTitle"
            style={{ fontSize: "16px", fontWeight: "normal", marginTop: "5px" }}
          >
            Click{" "}
            <a
              href="https://www.speqqle.com/prices"
              target="_blank"
              rel="noopener noreferrer"
              className="subscriptionLink"
            >
              here
            </a>{" "}
            for details on our subscription plans.
          </div>
          {currentUser && currentUser.academic_verified && (
            <div
              className="packageSecTitle"
              style={{
                fontSize: "16px",
                fontWeight: "normal",
                marginTop: "5px",
              }}
            >
              You benefit from academic discounts (when applicable)
            </div>
          )} */}

          <div className="packageArea">
            <div className="areaTitle">Active Subscription:</div>
            {activePacks.length > 0 ? (
              <div className="activePacks" id="active-packages-container">
                {activePacks.map((pack) => {
                  const foundPack = getPackageFromList(
                    packages,
                    pack.package_id
                  );
                  if (foundPack !== undefined) {
                    return (
                      <Package
                        key={pack.id}
                        id={foundPack.id}
                        userPackageId={pack.id}
                        title={foundPack.name}
                        price={foundPack.cost}
                        description={foundPack.description}
                        activeTill={pack.end}
                        subscription={foundPack.is_subscription}
                        subscription_active={
                          pack.subscription_active ? true : false
                        }
                        available={foundPack.available}
                        handlePurchaseInit={handlePurchaseInit}
                        handleDeactivatePackage={handleDeactivatePackage}
                        active
                      />
                    );
                  } else {
                    return;
                  }
                })}
              </div>
            ) : (
              <div className="noActive">None</div>
            )}
            <div className="areaTitle">Available Upgrades:</div>
            {packages.map((pack) => {
              if (isPackAvailable(pack)) {
                return (
                  <Package
                    key={pack.id}
                    id={pack.id}
                    title={pack.name}
                    description={pack.description}
                    price={pack.cost}
                    length={pack.months}
                    length_days={pack.days ? pack.days : 0}
                    subscription={pack.is_subscription}
                    available={pack.available}
                    handlePurchaseInit={handlePurchaseInit}
                  />
                );
              } else {
                return null;
              }
            })}
            {/* {expiredPacks.length > 0 ? (
              <>
                <div className="areaTitle">Expired:</div>
                <div className="activePacks last">
                  {expiredPacks.map((pack) => {
                    const foundPack = getPackageFromList(
                      packages,
                      pack.package_id
                    );
                    if (foundPack !== undefined) {
                      return (
                        <Package
                          key={pack.id}
                          id={pack.id}
                          title={foundPack.name}
                          description={foundPack.description}
                          price={foundPack.cost}
                          activeTill={pack.end}
                          available={foundPack.available}
                          handlePurchaseInit={handlePurchaseInit}
                          active
                          expired
                        />
                      );
                    } else {
                      return;
                    }
                  })}
                </div>
              </>
            ) : (
              <></>
            )} */}
            {/* {currentUser && !currentUser.academic_verified && (
              <div style={{ marginTop: "40px" }}>
                <Button
                  variant="contained"
                  onClick={() => setAcademicDiscountModalOpen(true)}                  className="toSpeqqleButton"
                >
                  Apply for Academic Discount
                </Button>
              </div>
            )} */}
          </div>
        </div>
        {activePolls.length > 0 || newsMessages.length > 0 ? (
          <div
            className="pollArea"
            style={{ zIndex: 50, position: "relative" }}
          >
            {activePolls.length > 0 && (
              <>
                <div className="pollsTitle">Active polls:</div>
                <div className="pollCounter">
                  {activePolls.length} polls remaining
                </div>
                <div className="solveArea">
                  {pollToSolve !== null ? (
                    <PollSolver
                      question={pollToSolve.question}
                      pollId={pollToSolve.id}
                      endDate={pollToSolve.closing_date}
                      handleSolved={handleSolvedPoll}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </>
            )}
            {newsMessages.length > 0 && (
              <>
                <div className="pollsTitle">Latest News:</div>
                <div className="newsList">
                  {newsMessages.map((news, index) => (
                    <NewsItem
                      key={index}
                      title={news.title}
                      content={news.content}
                      creation_date={news.creation_date}
                      newstype={news.newstype}
                    />
                  ))}
                </div>
                {!showAllNews && newsMessages.length === 10 && (
                  <div style={{ marginTop: "15px", textAlign: "left" }}>
                    <Button
                      variant="contained"
                      onClick={handleIncludeOlderNews}
                      className="toSpeqqleButton"
                    >
                      Include older news
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      <Modal
        isOpen={purchaseModalOpen}
        onRequestClose={handlePurchaseModalClose}
        shouldCloseOnOverlayClick={true}
        contentLabel="Purchase Modal"
        appElement={profileHomeRef.current}
        style={{
          content: {
            width: "90vw",
            height: "90vh",
            top: "5%",
            left: "5%",
            zIndex: "1000",
          },
          overlay: {
            zIndex: "1010",
          },
        }}
      >
        <div className="purchaseModal">PURCHASE MODAL</div>
      </Modal>
      <Modal
        isOpen={academicDiscountModalOpen}
        onRequestClose={() => setAcademicDiscountModalOpen(false)}
        shouldCloseOnOverlayClick={true}
        appElement={profileHomeRef.current}
        style={{
          content: {
            width: "500px",
            height: "350px",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            zIndex: "9999",
          },
          overlay: {
            zIndex: "9999",
          },
        }}
      >
        <div className="feedbackModal">
          <div className="text" style={{ fontSize: "14px", lineHeight: "1.4" }}>
            You are eligible for academic discounts if:
            <ul>
              <li>
                You are a student, teacher, or staff member of a university or
                educational institution.
              </li>
              <li>
                The purpose of your analysis is either academic or educational.
              </li>
            </ul>
            To apply for an academic discount, please contact us at <br />
            <br />
            <a href="mailto:contact@speqqle.com?subject=Academic Discount Application">
              contact@speqqle.com
            </a>{" "}
            <br />
            <br />
            and attach a proof of your academic status, such as a copy of your
            student or staff ID.
          </div>
        </div>
      </Modal>

      {/* Payment Frequency Modal */}
      <Modal
        isOpen={paymentFrequencyModalOpen}
        onRequestClose={() => {
          setPaymentFrequencyModalOpen(false);
          setPendingPurchaseData(null);
          setPendingTaxingPurpose(null);
        }}
        shouldCloseOnOverlayClick={true}
        appElement={profileHomeRef.current}
        style={{
          content: {
            width: "500px",
            height: "260px",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            zIndex: "10000",
          },
          overlay: {
            zIndex: "10000",
          },
        }}
      >
        <div className="feedbackModal">
          <div
            className="text"
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            How would you like to pay for your subscription?
          </div>
          <div
            style={{ display: "flex", gap: "40px", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              onClick={() => handlePaymentFrequencySelection("year")}
              className="toSpeqqleButton"
            >
              Yearly
            </Button>
            <Button
              variant="contained"
              onClick={() => handlePaymentFrequencySelection("month")}
              className="toSpeqqleButton"
            >
              Monthly
            </Button>
          </div>
          <div
            className="text"
            style={{
              fontSize: "16px",
              marginTop: "10px",
            }}
          >
            For details on discounts and other benefits for yearly payment,
            please contact us at:
            <a href="mailto:contact@speqqle.com?subject=Yearly Payment Benefits">
              contact@speqqle.com
            </a>.
            <br />
            You can deactivate your subscription at any time. Your package
            remains active until the end of the current billing period.
          </div>
        </div>
      </Modal>

      {/* Taxing Purpose Modal */}
      <Modal
        isOpen={taxingPurposeModalOpen}
        onRequestClose={() => {
          setTaxingPurposeModalOpen(false);
          setPendingPurchaseData(null);
        }}
        shouldCloseOnOverlayClick={true}
        appElement={profileHomeRef.current}
        style={{
          content: {
            width: "400px",
            height: "200px",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            zIndex: "9999",
          },
          overlay: {
            zIndex: "9999",
          },
        }}
      >
        <div className="feedbackModal">
          <div
            className="text"
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            For taxing purposes, are you purchasing this plan as a private
            individual or a company?
          </div>
          <div
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <Button
              variant="contained"
              onClick={() => handleTaxingPurposeSelection("private")}
              className="toSpeqqleButton"
            >
              Private
            </Button>
            <Button
              variant="contained"
              onClick={() => handleTaxingPurposeSelection("company")}
              className="toSpeqqleButton"
            >
              Company
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ProfileHome;
